export enum CurrencyActionTypes {
  API_RESPONSE_SUCCESS = "@@currency/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@currency/API_RESPONSE_ERROR",

  CREATE_CURRENCY = "@@currency/CREATE_CURRENCY",
  GET_CURRENCY = "@@currency/GET_CURRENCY",
  UPDATE_CURRENCY = "@@currency/UPDATE_CURRENCY",
  DELETE_CURRENCY = "@@currency/DELETE_CURRENCY",
}
